/* eslint-disable no-empty-pattern */
import React from "react"
import PropTypes from "prop-types"
import { find } from "ramda"
import {
  Button,
  Checkbox,
  Divider,
  Form,
  Icon,
  Input,
  Label,
  Menu,
  Popup,
  Segment,
  Sidebar,
  Table,
  Modal,
  Header,
  Card,
  Select,
  Dropdown,
  Accordion,
  // Popup,
  // Icon,
} from "semantic-ui-react"
import Info from "./Info"
import ruLocale from "date-fns/locale/ru"
import { format } from "date-fns"
import bind from "bind-decorator"
import { coalesce } from "../utils/logical"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import TreeMenu from "react-simple-tree-menu"
import ReactExport from "react-export-excel"
import Barcode from "../components/BarCode"
import ReactToPrint from "react-to-print"
import { getCheck } from "../config/apiUrls"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn
const maxWidth = 600

const getDefaultState = () => ({
  selected: [],
  isEditing: false,
  isDeleting: false,
  editedData: {},
  editedFilter: {},
  lastFilterValue: "",
  openedFilterColumn: "",
  modal: false,
  stockId: null,
  discountId: null,
  categoryId: null,
  modalAddToCategory: false,
  media: window.innerWidth > maxWidth,
})
class EditableTable extends React.Component {
  constructor(props) {
    super(props)
    this.lastAction = 0
    this.state = getDefaultState()
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading) {
      this.setState(getDefaultState())
    }
  }

  componentDidUpdate() {
    // this.setAccordion()
    // eslint-disable-next-line prettier/prettier
    if (window.innerWidth > maxWidth !== this.state.media) {
      this.setState({ media: window.innerWidth > maxWidth })
    }
  }

  open = { open: false }

  openTrue = () => {
    this.open = { open: true }
    this.setState({ u: true })
  }

  handleCategoryClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
  }

  categories = (el) => {
    return (
      <>
        {el.nodes ? (
          <>
            <p className="item" onClick={this.setCategories}>
              {el.label + (el.nodes ? " +" : "")}
            </p>
            <div
              className="panel"
              style={{
                display: "none",
                paddingLeft: 20,
                height: "max-content",
              }}
            >
              {el.nodes.map((q) => this.categories(q))}
            </div>
          </>
        ) : (
          <Dropdown.Item onClick={() => this.setCategory(el)}>
            <p style={{ height: 30 }}>{el.label}</p>
          </Dropdown.Item>
        )}
      </>
    )
  }

  setCategory = (val) => {
    this.open = { open: false }
    this.setState({ u: false })
    this.setState({ categoryId: val.key })
    this.setState({ category: val.label })
  }

  setCategories = (e) => {
    this.open = { open: true }
    this.setState({ u: true })
    let a = e.target
    a.classList.toggle("active")
    if (~a.childNodes[0].nodeValue.indexOf("+")) {
      let l = a.childNodes[0].nodeValue.split(" ").length
      a.innerText =
        a.childNodes[0].nodeValue
          .split(" ")
          .slice(0, l - 1)
          .join() + " -"
    } else if (~a.childNodes[0].nodeValue.indexOf("-")) {
      let l = a.childNodes[0].nodeValue.split(" ").length
      a.innerText =
        a.childNodes[0].nodeValue
          .split(" ")
          .slice(0, l - 1)
          .join() + " +"
    }
    let panel = a.nextElementSibling
    if (panel) {
      if (panel.style.display === "block") {
        panel.style.display = "none"
      } else {
        panel.style.display = "block"
      }
    }
  }

  @bind
  openFilters({}, { data }) {
    const { activeFilters } = this.props
    const editedFilter = find((f) => f.column === data)(activeFilters) || {
      column: data,
    }
    this.setState({ openedFilterColumn: data, editedFilter })
  }

  @bind
  editData(id, changes) {
    if (!changes.quantity || changes.quantity.match(/^\d{1,}(\.\d{0,4})?$/)) {
      const { editedData } = this.state
      const prev = editedData[id] ? editedData[id] : {}
      this.setState({
        editedData: { ...editedData, [id]: { ...prev, ...changes } },
      })
    }
  }

  @bind
  setFilterRanges(isFrom) {
    return ({}, { value }) => {
      if (!value || value.match(/^\d{1,}(\.\d{0,4})?$/)) {
        const { editedFilter } = this.state
        const item = { ...editedFilter }
        if (isFrom) {
          item.rangeFrom = value
        } else {
          item.rangeTo = value
        }
        this.setState({ editedFilter: item })
      }
    }
  }

  @bind
  removeFilterValue({}, { data }) {
    const { editedFilter } = this.state
    this.lastAction = Date.now()
    this.setState({
      editedFilter: {
        ...editedFilter,
        values: editedFilter.values.filter((f) => f !== data),
      },
    })
  }

  @bind
  addFilterValue() {
    const { editedFilter, lastFilterValue } = this.state
    const old = editedFilter.values || []
    this.setState({
      editedFilter: {
        ...editedFilter,
        values: [...old, lastFilterValue],
      },
      lastFilterValue: "",
    })
  }

  @bind
  closeFilters() {
    if (Date.now() - this.lastAction > 300) {
      this.setState({
        editedFilter: {},
        lastFilterValue: "",
        openedFilterColumn: "",
      })
    }
  }

  @bind
  applyFilters() {
    const { editedFilter, openedFilterColumn } = this.state
    const { changeFilters, activeFilters } = this.props
    const newFilters = activeFilters
      ? activeFilters.filter((f) => f.column !== openedFilterColumn)
      : []
    this.lastAction = 0
    newFilters.push({ ...editedFilter })
    changeFilters(newFilters)
    this.setState({
      openedFilterColumn: "",
      lastFilterValue: "",
    })
  }

  @bind
  clearFilters() {
    this.setState({
      editedFilter: {
        rangeFrom: "",
        rangeTo: "",
      },
      lastFilterValue: "",
    })
  }

  @bind
  selectAll() {
    const { data } = this.props
    const { selected } = this.state
    if (selected.length === data.length) {
      this.setState(getDefaultState())
    } else {
      this.setState({ selected: data.map((item) => item.id) })
    }
  }

  @bind
  select({}, { value }) {
    const { selected, editedData, isEditing } = this.state
    if (find((item) => item === value)(selected)) {
      const newEditedData = { ...editedData }
      delete newEditedData[value]
      const filtered = selected.filter((item) => item !== value)
      this.setState({
        selected: filtered,
        editedData: newEditedData,
        isEditing: isEditing && filtered.length > 0,
      })
    } else {
      this.setState({ selected: [...selected, value] })
    }
  }

  @bind
  selectRow(data) {
    const { selected } = this.state
    const { onSelect } = this.props
    if (!onSelect || selected.length > 0) {
      return null
    }
    return (e) => {
      if (data.saleId) {
        this.props.setCheckNum(data.saleId)
      }
      if (e.nativeEvent.target.tagName !== "LABEL") {
        onSelect(data)
        window.clickId = data.id
      }
    }
  }

  @bind
  handleModalOpen() {
    this.setState({
      modal: true,
      stockId: this.state.selected,
    })
  }

  @bind
  handleModalAddToCategoryOpen() {
    this.setState({
      modalAddToCategory: true,
      stockId: this.state.selected,
    })
  }

  @bind
  handleModalClose() {
    this.setState({
      modal: false,
      stockId: null,
      discountId: null,
    })
    this.cancel()
  }

  @bind
  handleModalAddToCategoryClose() {
    this.setState({
      modalAddToCategory: false,
      stockId: null,
      categoryId: null,
    })
  }

  @bind
  handleDiscountSelect({}, { value }) {
    this.setState({
      discountId: value,
    })
  }

  @bind
  handleModalSend() {
    const data = {
      stocks: this.state.stockId,
      discountId: this.state.discountId,
    }
    this.props.addItemsToDiscount(data)
    this.setState({
      modal: false,
      stockId: null,
      discountId: null,
    })
    this.props.supplyRefresh()
    this.cancel()
  }

  @bind
  startEditing() {
    this.setState({ isEditing: true })
  }

  @bind
  cancel() {
    this.setState({
      selected: [],
      isEditing: false,
      isDeleting: false,
      editedData: {},
    })
  }

  @bind
  sortBy(column) {
    return (e) => {
      if (e.nativeEvent.target.tagName === "TH") {
        const { onSort, sortedAsc } = this.props
        onSort(column, !sortedAsc)
      }
    }
  }

  @bind
  saveChanges() {
    // TODO: show that rows are editing
    const { onEdit } = this.props
    const { editedData } = this.state
    onEdit(editedData)
    this.cancel()
  }

  @bind
  startDeleting() {
    this.setState({ isDeleting: true })
  }

  @bind
  deleteSelected() {
    const { onDelete } = this.props
    const { selected } = this.state
    onDelete(selected)
    window.setTimeout(() => {
      this.props.onModalClose()
    }, 500)
    this.cancel()
  }

  @bind
  changeLastFilterValue({}, { value }) {
    this.setState({ lastFilterValue: value })
  }

  @bind
  renderFilters(col) {
    const { t } = this.props
    if (!col.filters || col.filters.length === 0) {
      return null
    }
    const { editedFilter, openedFilterColumn } = this.state
    let rangeFilter = null
    if (find((f) => f === "range")(col.filters)) {
      // TODO: support "date" type
      rangeFilter = (
        <Form>
          <label>Мин</label>
          <Form.Input
            name="minRange"
            value={coalesce(editedFilter.rangeFrom, "") || ""}
            type="text"
            onChange={this.setFilterRanges(true)}
          />
          <label>Макс</label>
          <Form.Input
            name="maxRange"
            value={coalesce(editedFilter.rangeTo) || ""}
            type="text"
            onChange={this.setFilterRanges(false)}
          />
          <Divider />
        </Form>
      )
    }
    let valuesFilter = null
    if (find((f) => f === "values")(col.filters)) {
      // TODO: support "date" type
      const { lastFilterValue } = this.state
      const selected = editedFilter.values
        ? editedFilter.values.map((value, i) => (
            <Label
              key={i}
              data={value}
              onRemove={this.removeFilterValue}
              content={value}
            />
          ))
        : null
      valuesFilter = (
        <div>
          <label>{t("value")}</label>
          <div>{selected}</div>
          <Form onSubmit={this.addFilterValue}>
            <Form.Input
              icon={
                <Info text={t("To add a filter, press Enter, then Apply")} />
              }
              className="values-filter"
              value={lastFilterValue}
              onChange={this.changeLastFilterValue}
            />
          </Form>
          <Divider />
        </div>
      )
    }
    return (
      <Popup
        className="editable-table-filters"
        wide
        trigger={<Icon name="filter" link />}
        on="click"
        open={openedFilterColumn === col.name}
        // hoverable
        data={col.name}
        onOpen={this.openFilters}
        onClose={this.closeFilters}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Icon
            name="close"
            color="red"
            size="large"
            onClick={this.closeFilters}
            style={{ cursor: "pointer" }}
          />
        </div>
        {rangeFilter}
        {valuesFilter}
        <Button
          fluid
          color="green"
          content={t("apply")}
          onClick={this.applyFilters}
          style={{ marginBottom: "10px" }}
        />
        <Button fluid content={t("clear")} onClick={this.clearFilters} />
      </Popup>
    )
  }

  @bind
  renderHeaders(noOptions) {
    const { t } = this.props
    const { selected } = this.state
    const { columns, data, sortedBy, sortedAsc } = this.props
    const direction = sortedAsc ? "ascending" : "descending"
    // TODO: mark active filters
    const headers = columns.map((col) => {
      return (
        <Table.HeaderCell
          style={{ whiteSpace: "pre" }}
          key={col.name}
          sorted={col.sortable && col.name === sortedBy ? direction : null}
          onClick={col.sortable ? this.sortBy(col.name) : null}
        >
          {t(col.title)} {col.filters && this.renderFilters(col)}
        </Table.HeaderCell>
      )
    })
    return (
      <Table.Row>
        <Table.HeaderCell
          // className={noOptions && !this.state.media ? "checkbox--hidden" : ""}
          style={{ display: noOptions ? "none" : "" }}
          collapsing
        >
          <Checkbox
            // className={noOptions ? "checkbox--hidden" : ""}
            style={{ display: noOptions ? "none" : "" }}
            onChange={this.selectAll}
            checked={selected.length === data.length}
          />
        </Table.HeaderCell>
        {headers}
      </Table.Row>
    )
  }

  exportExcelData = () => {
    const res = this.props.data.map((el) => {
      const r = el
      return r
    })
    return res
  }

  @bind
  renderRows(noOptions) {
    const { isEditing, selected, editedData } = this.state
    const { columns, data } = this.props
    return data.map((item, idx) => {
      const isSelected = !!find((id) => id === item.id)(selected)
      const items = [
        <Table.Cell
          key="checkbox"
          className={noOptions && !this.state.media ? "checkbox--hidden" : ""}
          style={{
            cursor: "pointer",
            display: noOptions ? "none" : "",
          }}
        >
          <Checkbox
            onChange={this.select}
            value={item.id}
            checked={isSelected}
            style={{ display: noOptions ? "none" : "" }}
          />
        </Table.Cell>,
      ]
      const editedItem = editedData[item.id]
      columns.map((col) => {
        const newData = { ...item, ...editedItem }
        if (isEditing && isSelected && col.editable) {
          let value = null
          if (col.renderEditing) {
            value = col.renderEditing(newData, this.editData)
          } else {
            if (col.dataType === "number") {
              value = (
                <Input
                  value={newData[col.name]}
                  type="number"
                  fluid
                  onChange={({}, { value }) =>
                    this.editData(newData.id, { [col.name]: value })
                  }
                />
              )
            } else {
              value = (
                <Input
                  value={newData[col.name]}
                  fluid
                  onChange={({}, { value }) =>
                    this.editData(newData.id, { [col.name]: value })
                  }
                />
              )
            }
            // TODO: support "date" type
          }
          items.push(
            <Table.Cell
              key={col.name}
              content={value}
              style={{ cursor: "pointer" }}
            />,
          )
        } else {
          let value = null
          if (col.render) {
            value = col.render(item, this.props.t, this.props.measures)
          } else {
            value = item[col.name]
          }

          if (col.dataType === "date") {
            value = value
              ? format(new Date(value), "d MMM yyyy, HH:mm", {
                  locale: ruLocale,
                })
              : ""
          }
          // if (col.name === "button") {
          //   items.push(
          //     <Table.Cell
          //       onClick={this.handleModalOpen}
          //       key={col.name}
          //       content={value}
          //     />,
          //   )
          // }
          if (
            col.name === "purchasePrice" ||
            col.name === "quantity" ||
            col.name === "remainder" ||
            col.name === "total" ||
            col.name === "salePrice"
          ) {
            items.push(
              <Table.Cell
                onClick={() => {
                  this.props.setProdName(item.name)
                  this.selectRow(item)
                }}
                textAlign="right"
                key={col.name}
                content={value}
                style={{ cursor: "pointer" }}
              />,
            )
          } else {
            if (col.name !== "button") {
              items.push(
                <Table.Cell
                  /* onClick={() => {
                    if (item.saleId) {
                      this.props.setCheckNum(item.saleId)
                    }
                    this.selectRow(item)
                  }} */
                  onClick={this.selectRow(item)}
                  key={col.name}
                  content={value}
                  style={{ cursor: "pointer" }}
                />,
              )
            }
          }
        }
      })

      return (
        <Table.Row
          key={idx}
          // key={item.barcode ? item.id + idx + item.barcode : item.id + idx}
          // onClick={this.selectRow(item)}
        >
          {items}
        </Table.Row>
      )
    })
  }

  render() {
    const { t } = this.props
    const { selected, isDeleting, isEditing, discountId } = this.state
    const {
      onDelete,
      onEdit,
      onAdd,
      isLoading,
      onSelect,
      noOptions,
      discountOptions,
      categories,
      checkNum,
    } = this.props
    const rows = this.renderRows(noOptions)
    const saveChangesItems = [
      <Menu.Item key="save">
        <Button
          content={t("saveChanges")}
          positive
          onClick={this.saveChanges}
        />
      </Menu.Item>,
      <Menu.Item key="cancel">
        <Button content={t("cancel")} onClick={this.cancel} />
      </Menu.Item>,
    ]
    const confirmDeleteItems = [
      <Menu.Item key="save">
        <Button
          content={"Удалить выбранные строки"}
          negative
          onClick={this.deleteSelected}
        />
      </Menu.Item>,
      <Menu.Item key="cancel">
        <Button content={t("cancel")} onClick={this.cancel} />
      </Menu.Item>,
    ]
    const chooseActionItems = []
    if (onEdit) {
      chooseActionItems.push(
        <Menu.Item key="edit">
          <Button content={t("change")} positive onClick={this.startEditing} />
        </Menu.Item>,
      )
    }
    if (onAdd) {
      chooseActionItems.push(
        <Menu.Item key="add">
          <Button
            content={t("addToDiscount")}
            positive
            onClick={this.handleModalOpen}
          />
        </Menu.Item>,
      )
      /* chooseActionItems.push(
        <Menu.Item key="add1">
          <Button
            content={t("AddToCategory")}
            positive
            onClick={this.handleModalAddToCategoryOpen}
          />
        </Menu.Item>,
      ) */
      if (this.state.media)
        chooseActionItems.push(
          // pointLoad
          <Menu.Item key="add2">
            <ReactToPrint
              trigger={() => (
                <Button
                  content={
                    "Распечатать штрих-код" +
                    (this.state.selected.length > 1 ? "ы" : "")
                  }
                  positive
                />
              )}
              content={() => {
                return this.componentRef
              }}
            />
          </Menu.Item>,
        )
    }
    if (onDelete) {
      chooseActionItems.push(
        <Menu.Item key="delete">
          <Button content={t("delete")} negative onClick={this.startDeleting} />
        </Menu.Item>,
      )
    }
    if (this.state.media)
      chooseActionItems.push(
        <Menu.Item key="export">
          <ExcelFile
            filename={this.props.title}
            element={<Button content={"Экспорт в Excel"} />}
          >
            <ExcelSheet
              data={
                this.state.selected.length
                  ? this.state.selected.map((el) =>
                      this.props.data.find((q) => q.id === el),
                    )
                  : this.props.data
              }
              name={this.props.name || this.props.title}
            >
              {this.props.columns.map((el) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <ExcelColumn
                    label={t(el.name ? el.name : el.title)}
                    value={el.name ? el.name : el.title}
                  />
                )
              })}
            </ExcelSheet>
          </ExcelFile>
        </Menu.Item>,
      )
    chooseActionItems.push(
      <Menu.Item key="cancel">
        <Button content={t("cancel")} onClick={this.cancel} />
      </Menu.Item>,
    )

    return (
      <Segment basic className="editable-table" loading={isLoading}>
        {this.state.media && !this.props.noOptions ? (
          <ExcelFile
            filename={this.props.title}
            element={
              <Button>
                <p>{t("Export to Excel")}</p>
              </Button>
            }
          >
            <ExcelSheet
              data={this.props.data}
              name={this.props.name || this.props.title}
            >
              {this.props.columns.map((el) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <ExcelColumn
                    label={t(el.name ? el.name : el.title)}
                    value={el.name ? el.name : el.title}
                  />
                )
              })}
            </ExcelSheet>
          </ExcelFile>
        ) : (
          <></>
        )}
        <div
          ref={(el) => (this.componentRef = el)}
          style={{ position: "absolute", zIndex: "-1", marginTop: 40 }}
        >
          {this.props.barcodable &&
            this.state.selected.map((el) => (
              <>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Barcode
                    value={
                      this.props.data.find((q) => q.id === el).barcode
                        ? this.props.data.find((q) => q.id === el).barcode
                        : "0"
                    }
                  />
                  <p>{this.props.data.find((q) => q.id === el).name}</p>
                </div>
              </>
            ))}
        </div>
        {this.props.salesPage ? (
          <a href={getCheck + this.props.checkNum()}>Чек</a>
        ) : (
          <></>
        )}
        <Table
          unstackable
          compact
          celled
          sortable
          definition
          selectable={!!onSelect}
        >
          <Table.Header fullWidth>{this.renderHeaders(noOptions)}</Table.Header>
          <Table.Body>{rows}</Table.Body>
        </Table>
        <Sidebar
          as={Menu}
          animation="overlay"
          direction="bottom"
          visible={selected.length > 0}
          inverted
          borderless
          className="editable-table-context-menu"
        >
          {isEditing
            ? saveChangesItems
            : isDeleting
            ? confirmDeleteItems
            : chooseActionItems}
        </Sidebar>
        {this.state.modalAddToCategory && (
          <Modal
            open
            size="small"
            style={{ position: "fixed", top: "15%" }}
            onClose={this.handleModalAddToCategoryClose}
            closeIcon="close"
          >
            <Header>{t("AddingToCategory")}</Header>
            <Modal.Content>
              {
                // <TreeMenu data={categories} />
              }
              {
                // categories.map((el) => this.categories(el))
              }
              <Dropdown selection fluid text={this.state.category}>
                <Dropdown.Menu open={this.open.open}>
                  {this.props.categories.map((el) => this.categories(el))}
                </Dropdown.Menu>
              </Dropdown>
              <div
                style={{
                  float: "right",
                  marginTop: "15px",
                  marginBottom: "20px",
                }}
              >
                {/* <Button
                  content={t("createDiscount")}
                  color="green"
                  style={{ position: "fixed", left: 22 }}
                  onClick={() => this.props.history.push("/discount")}
                /> */}
                <Button
                  content={t("cancel")}
                  onClick={this.handleModalAddToCategoryClose}
                />
                <Button
                  color="green"
                  content={t("add")}
                  onClick={() => {
                    this.handleModalAddToCategoryClose()
                    if (this.state.categoryId) {
                      this.state.stockId.map((el) => {
                        this.props.addToCategory(el, this.state.categoryId)
                      })
                    }
                  }}
                  // onClick={this.handleModalSend}
                />
              </div>
            </Modal.Content>
          </Modal>
        )}
        {this.state.modal && (
          <Modal
            open
            size="small"
            style={{ position: "fixed", top: "15%" }}
            onClose={this.handleModalClose}
            closeIcon="close"
          >
            <Header>{t("createPromotionalItem")}</Header>
            <Modal.Content>
              <Card.Content key="1">
                <Form>
                  <Form.Select
                    options={discountOptions}
                    label={t("discountPage")}
                    id="discountId"
                    name="discountId"
                    value={discountId}
                    onChange={this.handleDiscountSelect}
                  />
                </Form>
              </Card.Content>
              <div
                style={{
                  float: "right",
                  marginTop: "15px",
                  marginBottom: "20px",
                }}
              >
                <Button
                  content={t("createDiscount")}
                  color="green"
                  style={{ position: "fixed", left: 22 }}
                  onClick={() => this.props.history.push("/discount")}
                />
                <Button content={t("cancel")} onClick={this.handleModalClose} />
                <Button
                  color="green"
                  content={t("add")}
                  onClick={this.handleModalSend}
                />
              </div>
            </Modal.Content>
          </Modal>
        )}
      </Segment>
    )
  }
}

EditableTable.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
      dataType: PropTypes.string,
      editable: PropTypes.bool,
      sortable: PropTypes.bool,
      render: PropTypes.func,
      renderEditing: PropTypes.func,
      filters: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
  activeFilters: PropTypes.arrayOf(
    PropTypes.shape({
      column: PropTypes.string,
      rangeFrom: PropTypes.any,
      rangeTo: PropTypes.any,
      values: PropTypes.arrayOf(PropTypes.any),
    }),
  ),
  sortedBy: PropTypes.string,
  sortedAsc: PropTypes.bool,
  onSort: PropTypes.func,
  changeFilters: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  noOptions: PropTypes.bool,
}

export default withTranslation()(withRouter(EditableTable))
